import { NordEvent } from '../common/events.js'

/**
 * Event dispatched when the layout's navigation sidebar width changes.
 * The `width` property contains the new width in pixels.
 */
export class NavResizeEvent extends NordEvent {
  declare width: number

  constructor(width: number) {
    super('nav-resize')
    Object.defineProperty(this, 'width', {
      value: width,
      enumerable: true,
      writable: false,
    })
  }
}

declare global {
  interface HTMLElementEventMap {
    'nav-resize': NavResizeEvent
  }
  interface DocumentEventMap {
    'nav-resize': NavResizeEvent
  }
  interface WindowEventMap {
    'nav-resize': NavResizeEvent
  }
}
